import React from 'react'
import { PrivacyPolicy } from '@templates'

const Privacy = () => <PrivacyPolicy />

export default Privacy
